import PropTypes from "prop-types";
import React, { Component } from "react";

import { Spinner } from "reactstrap";

// Redux
import { connect } from "react-redux";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";

// actions
import { merchantLinkPaymentError, getMerchantLinkPaymentSpesificByKey } from "../../store/actions";
import { getLinkPaymentErrorMessage, linkPaymentSetIcon, linkPaymenSetMessage, linkPaymentIsSuccess, setMessage } from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";


import {
  CardPaymentForm,
  CheckoutErrorForm,
  ThreeDForm,
} from "components/Common/CombinedComponents";
import { documentTitleChange } from "components/Utils/utils";
import { getApiErrorDetails } from "helpers/apiErrorHelper";

class checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedClient: null,
      record: {
        message: "",
        code: "",
        details: "",
        correlationId: "",
        validationResults: [],
      },
      loading: true,
      open: false,
      redirectToErrorPage: false,
      selectedLang: "",
      checkoutError: null,
    };

  }

  componentDidMount() {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE") || "tr";
    localStorage.setItem("I18N_LANGUAGE", currentLanguage);
    i18n.changeLanguage(currentLanguage);
    this.setState({ selectedLang: "" });
    this.setState({ call: false });

    let key = this.getParameterByName();
    this.setState({ key: key });
    if (key === null || key === "") {
      this.setState({ redirectToErrorPage: true });
    }
    if (key !== undefined && key !== null) {
      this.props.onGetRecordList(key);
    }

  }
  componentDidUpdate(prevProps) {
    const { error, loading, recordList } = this.props;
    if (prevProps.error === error) {
      return;
    }
    if (!error || (typeof error === "object" && !error.response && !error.Code && !error.Message && !error.message && Object.keys(error).length === 0)) {
      this.setState({ checkoutError: null });
      return;
    }

    // Ödeme formu açıldıktan sonra ikincil API hataları (BIN/permission vb.) tüm ekranı kapatmasın
    const paymentFormVisible = !loading && recordList && !recordList.error && !recordList.nonSecureTransaction;
    if (paymentFormVisible) {
      return;
    }

    const details = getApiErrorDetails(error);
    if (!details.code && !details.message) {
      this.setState({ checkoutError: null });
      return;
    }

    this.setState({
      checkoutError: {
        code: details.code || "Error",
        message: details.message || this.props.t("linkPaymentErrorMessage"),
        details: details.details,
        correlationId: details.correlationId,
      },
    });
  }

  getParameterByName = () => {
    const pathParts = window.location.pathname.split('/');
    return pathParts[pathParts.length - 1];
  }

  render() {

    documentTitleChange(this.props.t("morparaLinkPayment"));

    if (this.state.checkoutError?.message) {
      const checkoutErrorRecord = {
        error: true,
        errorData: {
          Code: this.state.checkoutError.code,
          Message: this.state.checkoutError.message,
          Details: this.state.checkoutError.details,
          CorrelationId: this.state.checkoutError.correlationId,
        },
        errorStatus: 400,
      };
      return (
        <CheckoutErrorForm
          errorMessage={getLinkPaymentErrorMessage(checkoutErrorRecord) || this.state.checkoutError.message}
          errorIcon={linkPaymentSetIcon(checkoutErrorRecord)}
          errorResult={this.state.checkoutError.details || linkPaymenSetMessage(checkoutErrorRecord)}
          errorIsSuccess={linkPaymentIsSuccess(checkoutErrorRecord)}
        />
      );
    }

    return (
      <React.Fragment>
        {this.props.loading ? (
          <Spinner className="position-absolute top-50 start-50 primary" />
        ) :
          this.props.recordList?.error || this.props.recordList?.nonSecureTransaction ? (
            <CheckoutErrorForm
              errorMessage={getLinkPaymentErrorMessage(this.props.recordList)}
              errorIcon={linkPaymentSetIcon(this.props.recordList)}
              errorResult={linkPaymenSetMessage(this.props.recordList)}
              errorIsSuccess={linkPaymentIsSuccess(this.props.recordList)}
            />
          ) : this.props.recordList?.a !== undefined ?

            (
              <CardPaymentForm
                recordList={this.props.recordList}
              />
            ) :

            this.props.recordList?.secureTransaction ?
              (
                <ThreeDForm
                  base64Response={this.props.recordList}
                />

              ) : (
                <CardPaymentForm
                  recordList={this.props.recordList}
                />

              )
        }
      </React.Fragment>
    );
  }
}

checkout.propTypes = {
  recordList: PropTypes.any,
  onGetRecordList: PropTypes.func,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  loading: PropTypes.bool,
};

const mapStateToProps = ({
  merchantLinkPayment
}) => ({
  loading: merchantLinkPayment.loading,
  recordList: merchantLinkPayment.record,
  error: merchantLinkPayment.error,
});

const mapDispatchToProps = dispatch => ({
  onGetRecordList: record => dispatch(getMerchantLinkPaymentSpesificByKey(record)),
  error: error => dispatch(merchantLinkPaymentError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(checkout));
